export const paymentType = [
  {
    label: 'JM Paylater',
    value: 'JM_PAYLATER'
  },
  {
    label: 'Paper Paylater',
    value: 'PAPER_PAYLATER'
  },
  {
    label: 'Virtual Account',
    value: 'VIRTUAL_ACCOUNT'
  },
  {
    label: 'Tunai',
    value: 'TRANSFER'
  },
  {
    label: 'Tempo',
    value: 'TEMPO'
  },
  {
    label: 'Koinworks',
    value: 'KOINWORKS'
  },
  {
    label: 'Credilinq.ai',
    value: 'CREDILINQ'
  }
]

export const soStatus = [
  {
    label: 'Belum Dibayar',
    value: 'UNPAID'
  },
  {
    label: 'Sudah Dibayar',
    value: 'PAID'
  },
  {
    label: 'Pesanan Diproses',
    value: 'PROCESSED'
  },
  {
    label: 'Pesanan Terkirim',
    value: 'SENT'
  },
  {
    label: 'Pesanan Masuk',
    value: 'RECEIVED'
  },
  {
    label: 'Pesanan Selesai',
    value: 'FINISHED'
  },
  {
    label: 'Pesanan Dibatalkan',
    value: 'CANCELED'
  }
]

export const poStatus = [
  {
    label: 'Menunggu Konfirmasi',
    value: 'UNAPPROVED'
  },
  {
    label: 'Pembayaran',
    value: 'PAID'
  },
  {
    label: 'Pesanan Diproses',
    value: 'PROCESSED'
  },
  {
    label: 'Dikirim Sebagian',
    value: 'PARTIALLY_DELIVERED'
  },
  {
    label: 'Terkirim Semua',
    value: 'DELIVERED'
  },
  {
    label: 'Pesanan Selesai',
    value: 'FINISHED'
  },
  {
    label: 'Pesanan Dibatalkan',
    value: 'CANCELED'
  },
  {
    label: 'Pesanan Ditolak',
    value: 'REJECTED'
  }
]

export const doStatus = [
  {
    label: 'Belum Dijadwalkan',
    value: 'PROCESSED'
  },
  {
    label: 'Terjadwal',
    value: 'SCHEDULED'
  },
  {
    label: 'Sopir Ditugaskan',
    value: 'DRIVER_ASSIGNED'
  },
  {
    label: 'Sedang Dikirim',
    value: 'ON_DELIVERY'
  },
  {
    label: 'Terkirim',
    value: 'SENT'
  },
  {
    label: 'SJ Balik',
    value: 'RETURN_LETTER'
  },
  {
    label: 'Selesai',
    value: 'FINISHED'
  },
  {
    label: 'Dibatalkan',
    value: 'CANCELED'
  }
]

export const goodsHandoverStatus = [
  {
    label: 'Franco',
    value: 'FRANCO'
  },
  {
    label: 'Loco',
    value: 'LOCO'
  },
  {
    label: 'Loco Customer',
    value: 'LOCO_CUSTOMER'
  }
]

export const pricesTypeOptionsNonPPN = [
  {
    label: 'DPP',
    value: 'DPP'
  }
]

export const pricesTypeOptionsPPN = [
  ...pricesTypeOptionsNonPPN,
  {
    label: 'Include PPN',
    value: 'PPN'
  }
]

export const periodShipmentMethodOptions = [
  {
    label: 'Juragan Logistik',
    value: 'JM'
  },
  {
    label: 'Pick Up Vendor',
    value: 'PICKUP'
  },
  {
    label: 'Gratis Ongkir',
    value: 'VENDOR'
  }
]
